import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { AppProvider } from './context/AppContext';
import MenuPage from './pages/MenuPage';
import ProductDetail from './pages/ProductDetail';
import FridgesPage from './pages/FridgesPage';
import CheckoutPage from './pages/CheckoutPage';
import CompanyPage from './pages/CompanyPage';
import AdminPage from './pages/AdminPage';
import AffichesPage from './pages/AffichesPage';
import PwaPrompts from './components/PwaPrompts';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <AppProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<MenuPage />} />
            <Route path="/product/:id" element={<ProductDetail />} />
            <Route path="/emplacements" element={<FridgesPage />} />
            <Route path="/commande" element={<CheckoutPage />} />
            <Route path="/entreprise" element={<CompanyPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/affiches" element={<AffichesPage />} />
            <Route path="*" element={<MenuPage />} />
          </Routes>
          <PwaPrompts />
        </BrowserRouter>
      </AppProvider>
    </div>
  );
}

export default App;
